/**
 * Helper function to decide if user is on seller central
 */
export const checkWithinSeCe = () => {
  const isSeCeDomain = window.location.hostname.includes('sellercentral.amazon');
  const validHost = window.veeqoContext?.vqHost === 'SeCe';

  return isSeCeDomain || validHost;
};
